module.exports = __webpack_public_path__ + "img/edit.9d9d507a.svg";